module.exports = __webpack_public_path__ + "img/icon_2.579ec470.svg";